module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_5010.3e4a5d96.png";